import { dodoChatTypes } from '../../constants/types';
import Vue from 'vue';

const md = require('markdown-it')().use(require('markdown-it-multimd-table'));

const mila = require('markdown-it-link-attributes');

md.use(mila, {
  attrs: {
    target: '_blank'
  }
});
const { setConversations, setConversationMessages, clearConversationMessages } = dodoChatTypes.actions;

export const mutations = {
  [setConversations]: (state, { response }) => {
    Vue.set(state, 'conversations', response.data.value);
  },

  [setConversationMessages]: (state, { response }) => {
    response.data.value.forEach(item => {
      item.content = md.render(item.content);
    });
    Vue.set(state, 'conversationMessages', response.data.value);
  },

  [clearConversationMessages]: state => {
    Vue.set(state, 'conversationMessages', []);
  }
};
